{
  "AlpineEasy": [
    {
      "name": "Check_Point_2",
      "uniform_scale": 1,
      "position": {
        "x": 524.914978,
        "y": -72.053261,
        "z": 1609.72998
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Check_Point_2",
      "uniform_scale": 1,
      "position": {
        "x": 469.625,
        "y": -50.83231,
        "z": 1613.47998
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Start_Point",
      "uniform_scale": 1,
      "position": {
        "x": 645.16803,
        "y": -831.709106,
        "z": 110.084
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Check_Point_1",
      "uniform_scale": 1,
      "position": {
        "x": 486.019012,
        "y": -535.026123,
        "z": 676.150024
      },
      "quat": {
        "w": 0.931603,
        "x": 0,
        "y": -0.363478,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 642.710999,
        "y": -841.440308,
        "z": 97.760902
      },
      "quat": {
        "w": 0.999982,
        "x": 0,
        "y": -0.00600007,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 642.682007,
        "y": -839.661926,
        "z": 100.323997
      },
      "quat": {
        "w": 0.999982,
        "x": 0,
        "y": -0.00600007,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 644.471008,
        "y": -839.745483,
        "z": 100.343002
      },
      "quat": {
        "w": 0.999982,
        "x": 0,
        "y": -0.00600007,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 641.054993,
        "y": -839.763367,
        "z": 100.378998
      },
      "quat": {
        "w": 0.999982,
        "x": 0,
        "y": -0.00600007,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 640.877991,
        "y": -841.469482,
        "z": 97.952599
      },
      "quat": {
        "w": 0.999982,
        "x": 0,
        "y": -0.00600007,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 642.987976,
        "y": -843.000122,
        "z": 95.099403
      },
      "quat": {
        "w": 0.999982,
        "x": 0,
        "y": -0.00600007,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 643.051025,
        "y": -844.409241,
        "z": 92.487297
      },
      "quat": {
        "w": 0.999982,
        "x": 0,
        "y": -0.00600007,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 641.125,
        "y": -844.462646,
        "z": 92.621201
      },
      "quat": {
        "w": 0.999982,
        "x": 0,
        "y": -0.00600007,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 641.103027,
        "y": -843.025818,
        "z": 95.214104
      },
      "quat": {
        "w": 0.999982,
        "x": 0,
        "y": -0.00600007,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 645.038025,
        "y": -844.440796,
        "z": 92.780098
      },
      "quat": {
        "w": 0.999982,
        "x": 0,
        "y": -0.00600007,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 644.825989,
        "y": -843.063599,
        "z": 95.252403
      },
      "quat": {
        "w": 0.999982,
        "x": 0,
        "y": -0.00600007,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 644.745972,
        "y": -841.444153,
        "z": 97.939796
      },
      "quat": {
        "w": 0.999982,
        "x": 0,
        "y": -0.00600007,
        "z": 0
      }
    },
    {
      "name": "Finish_Point",
      "uniform_scale": 1.396,
      "position": {
        "x": 620.690979,
        "y": 372.30188,
        "z": 2564.110107
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    }
  ],
  "AlpineHard": [
    {
      "name": "Start_Point",
      "uniform_scale": 1,
      "position": {
        "x": 645.16803,
        "y": -831.709106,
        "z": 110.084
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 642.710999,
        "y": -841.440308,
        "z": 97.760902
      },
      "quat": {
        "w": 0.999982,
        "x": 0,
        "y": -0.00600007,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 642.682007,
        "y": -839.661926,
        "z": 100.323997
      },
      "quat": {
        "w": 0.999982,
        "x": 0,
        "y": -0.00600007,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 644.471008,
        "y": -839.745483,
        "z": 100.343002
      },
      "quat": {
        "w": 0.999982,
        "x": 0,
        "y": -0.00600007,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 641.054993,
        "y": -839.763367,
        "z": 100.378998
      },
      "quat": {
        "w": 0.999982,
        "x": 0,
        "y": -0.00600007,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 640.877991,
        "y": -841.469482,
        "z": 97.952599
      },
      "quat": {
        "w": 0.999982,
        "x": 0,
        "y": -0.00600007,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 642.987976,
        "y": -843.000122,
        "z": 95.099403
      },
      "quat": {
        "w": 0.999982,
        "x": 0,
        "y": -0.00600007,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 643.051025,
        "y": -844.409241,
        "z": 92.487297
      },
      "quat": {
        "w": 0.999982,
        "x": 0,
        "y": -0.00600007,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 641.125,
        "y": -844.462646,
        "z": 92.621201
      },
      "quat": {
        "w": 0.999982,
        "x": 0,
        "y": -0.00600007,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 641.103027,
        "y": -843.025818,
        "z": 95.214104
      },
      "quat": {
        "w": 0.999982,
        "x": 0,
        "y": -0.00600007,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 645.038025,
        "y": -844.440796,
        "z": 92.780098
      },
      "quat": {
        "w": 0.999982,
        "x": 0,
        "y": -0.00600007,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 644.825989,
        "y": -843.063599,
        "z": 95.252403
      },
      "quat": {
        "w": 0.999982,
        "x": 0,
        "y": -0.00600007,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 644.745972,
        "y": -841.444153,
        "z": 97.939796
      },
      "quat": {
        "w": 0.999982,
        "x": 0,
        "y": -0.00600007,
        "z": 0
      }
    },
    {
      "name": "Check_Point_2",
      "uniform_scale": 1,
      "position": {
        "x": 1051.060059,
        "y": 68.596832,
        "z": 1590.109985
      },
      "quat": {
        "w": 0.9987,
        "x": 0,
        "y": 0.0509779,
        "z": 0
      }
    },
    {
      "name": "Check_Point_1",
      "uniform_scale": 1,
      "position": {
        "x": 637.55603,
        "y": -585.382996,
        "z": 606.434998
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Finish_Point",
      "uniform_scale": 1,
      "position": {
        "x": 1119.880005,
        "y": 543.206604,
        "z": 2291.780029
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    }
  ],
  "AlpineMedium": [
    {
      "name": "Start_Point",
      "uniform_scale": 1,
      "position": {
        "x": 645.16803,
        "y": -831.709106,
        "z": 110.084
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 642.710999,
        "y": -841.440308,
        "z": 97.760902
      },
      "quat": {
        "w": 0.999982,
        "x": 0,
        "y": -0.00600007,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 642.682007,
        "y": -839.661926,
        "z": 100.323997
      },
      "quat": {
        "w": 0.999982,
        "x": 0,
        "y": -0.00600007,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 644.471008,
        "y": -839.745483,
        "z": 100.343002
      },
      "quat": {
        "w": 0.999982,
        "x": 0,
        "y": -0.00600007,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 641.054993,
        "y": -839.763367,
        "z": 100.378998
      },
      "quat": {
        "w": 0.999982,
        "x": 0,
        "y": -0.00600007,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 640.877991,
        "y": -841.469482,
        "z": 97.952599
      },
      "quat": {
        "w": 0.999982,
        "x": 0,
        "y": -0.00600007,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 642.987976,
        "y": -843.000122,
        "z": 95.099403
      },
      "quat": {
        "w": 0.999982,
        "x": 0,
        "y": -0.00600007,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 643.051025,
        "y": -844.409241,
        "z": 92.487297
      },
      "quat": {
        "w": 0.999982,
        "x": 0,
        "y": -0.00600007,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 641.125,
        "y": -844.462646,
        "z": 92.621201
      },
      "quat": {
        "w": 0.999982,
        "x": 0,
        "y": -0.00600007,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 641.103027,
        "y": -843.025818,
        "z": 95.214104
      },
      "quat": {
        "w": 0.999982,
        "x": 0,
        "y": -0.00600007,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 645.038025,
        "y": -844.440796,
        "z": 92.780098
      },
      "quat": {
        "w": 0.999982,
        "x": 0,
        "y": -0.00600007,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 644.825989,
        "y": -843.063599,
        "z": 95.252403
      },
      "quat": {
        "w": 0.999982,
        "x": 0,
        "y": -0.00600007,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 644.745972,
        "y": -841.444153,
        "z": 97.939796
      },
      "quat": {
        "w": 0.999982,
        "x": 0,
        "y": -0.00600007,
        "z": 0
      }
    },
    {
      "name": "Check_Point_1",
      "uniform_scale": 1,
      "position": {
        "x": 608.411011,
        "y": -551.169128,
        "z": 654.901001
      },
      "quat": {
        "w": 0.996218,
        "x": 0,
        "y": 0.0868903,
        "z": 0
      }
    },
    {
      "name": "Finish_Point",
      "uniform_scale": 1.396,
      "position": {
        "x": 620.711975,
        "y": 372.307526,
        "z": 2564.129883
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Check_Point_2",
      "uniform_scale": 1,
      "position": {
        "x": 718.445007,
        "y": -147.717392,
        "z": 1429.160034
      },
      "quat": {
        "w": 0.993846,
        "x": 0,
        "y": 0.110772,
        "z": 0
      }
    }
  ],
  "ForestEasy": [
    {
      "name": "Finish_Point",
      "uniform_scale": 1,
      "position": {
        "x": 534.888,
        "y": -284.277588,
        "z": 2313.639893
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Start_Point",
      "uniform_scale": 1,
      "position": {
        "x": 519.367981,
        "y": -1384.164185,
        "z": 99.7817
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Check_Point_2",
      "uniform_scale": 1,
      "position": {
        "x": 671.789978,
        "y": -631.825745,
        "z": 1691.939941
      },
      "quat": {
        "w": 0.996721,
        "x": 0,
        "y": -0.0809115,
        "z": 0
      }
    },
    {
      "name": "Check_Point_2",
      "uniform_scale": 1,
      "position": {
        "x": 334.958008,
        "y": -701.713623,
        "z": 1544.140015
      },
      "quat": {
        "w": 0.98965,
        "x": 0,
        "y": -0.143503,
        "z": 0
      }
    },
    {
      "name": "Check_Point_1",
      "uniform_scale": 1,
      "position": {
        "x": 259.109985,
        "y": -1044.600708,
        "z": 872.73999
      },
      "quat": {
        "w": 0.997823,
        "x": 0,
        "y": 0.0659521,
        "z": 0
      }
    },
    {
      "name": "Check_Point_2",
      "uniform_scale": 1,
      "position": {
        "x": 507.769989,
        "y": -691.222168,
        "z": 1560.670044
      },
      "quat": {
        "w": 0.990901,
        "x": 0,
        "y": 0.13459,
        "z": 0
      }
    },
    {
      "name": "Check_Point_1",
      "uniform_scale": 1,
      "position": {
        "x": 512.228027,
        "y": -1066.99585,
        "z": 843.586975
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 526.361023,
        "y": -1401.963379,
        "z": 52.828701
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 524.234009,
        "y": -1401.888062,
        "z": 52.872601
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 521.651001,
        "y": -1401.730713,
        "z": 53.207901
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 528.848999,
        "y": -1401.966797,
        "z": 52.491501
      },
      "quat": {
        "w": 0.999456,
        "x": 0,
        "y": -0.0329958,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 509.837006,
        "y": -1401.014038,
        "z": 55.337502
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 513.203979,
        "y": -1401.264648,
        "z": 54.7066
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 516.369995,
        "y": -1401.418091,
        "z": 54.133801
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 519.234009,
        "y": -1401.579346,
        "z": 53.577999
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Start_Point",
      "uniform_scale": 1.612,
      "position": {
        "x": 412.575012,
        "y": -232.187561,
        "z": -64.914001
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Check_Point_1",
      "uniform_scale": 1,
      "position": {
        "x": 723.994995,
        "y": -1124.040405,
        "z": 702.659973
      },
      "quat": {
        "w": 0.964567,
        "x": 0,
        "y": 0.263839,
        "z": 0
      }
    }
  ],
  "ForestHard": [
    {
      "name": "Check_Point_1",
      "uniform_scale": 1,
      "position": {
        "x": 723.994995,
        "y": -1247.439087,
        "z": 702.659973
      },
      "quat": {
        "w": 0.964567,
        "x": 0,
        "y": 0.263839,
        "z": 0
      }
    },
    {
      "name": "Start_Point",
      "uniform_scale": 1,
      "position": {
        "x": 518.552979,
        "y": -1535.383911,
        "z": 99.917
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Start_Point",
      "uniform_scale": 1.612,
      "position": {
        "x": 412.575012,
        "y": -257.285614,
        "z": -64.914001
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 519.234009,
        "y": -1554.089722,
        "z": 53.577999
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 516.369995,
        "y": -1553.914795,
        "z": 54.133801
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 513.203979,
        "y": -1553.747314,
        "z": 54.7066
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 509.837006,
        "y": -1553.481201,
        "z": 55.337502
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 528.848999,
        "y": -1554.503784,
        "z": 52.491501
      },
      "quat": {
        "w": 0.999456,
        "x": 0,
        "y": -0.0329958,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 521.651001,
        "y": -1554.250122,
        "z": 53.207901
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 524.234009,
        "y": -1554.415649,
        "z": 52.872601
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 526.361023,
        "y": -1554.492065,
        "z": 52.828701
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Check_Point_1",
      "uniform_scale": 1,
      "position": {
        "x": 512.228027,
        "y": -1185.055298,
        "z": 843.586975
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Check_Point_2",
      "uniform_scale": 1,
      "position": {
        "x": 507.769989,
        "y": -767.855957,
        "z": 1560.670044
      },
      "quat": {
        "w": 0.990901,
        "x": 0,
        "y": 0.13459,
        "z": 0
      }
    },
    {
      "name": "Check_Point_1",
      "uniform_scale": 1,
      "position": {
        "x": 259.109985,
        "y": -1160.998779,
        "z": 872.73999
      },
      "quat": {
        "w": 0.997823,
        "x": 0,
        "y": 0.0659521,
        "z": 0
      }
    },
    {
      "name": "Check_Point_2",
      "uniform_scale": 1,
      "position": {
        "x": 334.958008,
        "y": -779.157715,
        "z": 1544.140015
      },
      "quat": {
        "w": 0.98965,
        "x": 0,
        "y": -0.143503,
        "z": 0
      }
    },
    {
      "name": "Finish_Point",
      "uniform_scale": 1,
      "position": {
        "x": 543.77002,
        "y": -304.486206,
        "z": 2340.919922
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Check_Point_2",
      "uniform_scale": 1,
      "position": {
        "x": 671.789978,
        "y": -702.809082,
        "z": 1691.939941
      },
      "quat": {
        "w": 0.996721,
        "x": 0,
        "y": -0.0809115,
        "z": 0
      }
    }
  ],
  "ForestMedium": [
    {
      "name": "Check_Point_1",
      "uniform_scale": 1,
      "position": {
        "x": 723.994995,
        "y": -1247.439087,
        "z": 702.659973
      },
      "quat": {
        "w": 0.964567,
        "x": 0,
        "y": 0.263839,
        "z": 0
      }
    },
    {
      "name": "Start_Point",
      "uniform_scale": 1,
      "position": {
        "x": 518.552979,
        "y": -1535.383911,
        "z": 99.917
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Start_Point",
      "uniform_scale": 1.612,
      "position": {
        "x": 412.575012,
        "y": -257.285614,
        "z": -64.914001
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 519.234009,
        "y": -1554.089722,
        "z": 53.577999
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 516.369995,
        "y": -1553.914795,
        "z": 54.133801
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 513.203979,
        "y": -1553.747314,
        "z": 54.7066
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 509.837006,
        "y": -1553.481201,
        "z": 55.337502
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 528.848999,
        "y": -1554.503784,
        "z": 52.491501
      },
      "quat": {
        "w": 0.999456,
        "x": 0,
        "y": -0.0329958,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 521.651001,
        "y": -1554.250122,
        "z": 53.207901
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 524.234009,
        "y": -1554.415649,
        "z": 52.872601
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 526.361023,
        "y": -1554.492065,
        "z": 52.828701
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Check_Point_1",
      "uniform_scale": 1,
      "position": {
        "x": 512.228027,
        "y": -1185.055298,
        "z": 843.586975
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Check_Point_2",
      "uniform_scale": 1,
      "position": {
        "x": 507.769989,
        "y": -767.855957,
        "z": 1560.670044
      },
      "quat": {
        "w": 0.990901,
        "x": 0,
        "y": 0.13459,
        "z": 0
      }
    },
    {
      "name": "Check_Point_1",
      "uniform_scale": 1,
      "position": {
        "x": 259.109985,
        "y": -1160.998779,
        "z": 872.73999
      },
      "quat": {
        "w": 0.997823,
        "x": 0,
        "y": 0.0659521,
        "z": 0
      }
    },
    {
      "name": "Check_Point_2",
      "uniform_scale": 1,
      "position": {
        "x": 334.958008,
        "y": -779.157715,
        "z": 1544.140015
      },
      "quat": {
        "w": 0.98965,
        "x": 0,
        "y": -0.143503,
        "z": 0
      }
    },
    {
      "name": "Finish_Point",
      "uniform_scale": 1,
      "position": {
        "x": 543.77002,
        "y": -304.486206,
        "z": 2340.919922
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Check_Point_2",
      "uniform_scale": 1,
      "position": {
        "x": 671.789978,
        "y": -702.809082,
        "z": 1691.939941
      },
      "quat": {
        "w": 0.996721,
        "x": 0,
        "y": -0.0809115,
        "z": 0
      }
    }
  ],
  "VillageEasy": [
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 734.325012,
        "y": -461.033691,
        "z": 225.824997
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 732.656006,
        "y": -461.06723,
        "z": 225.498001
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 731.10199,
        "y": -461.079224,
        "z": 225.306
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 729.349976,
        "y": -461.088135,
        "z": 225.104996
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 727.888,
        "y": -461.091522,
        "z": 225
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 726.346985,
        "y": -461.093994,
        "z": 224.899994
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 724.721008,
        "y": -461.095154,
        "z": 224.837006
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 722.926025,
        "y": -461.089417,
        "z": 224.729996
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Check_Point_1",
      "uniform_scale": 1,
      "position": {
        "x": 490.509003,
        "y": -283.806305,
        "z": 607.773987
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Finish_Point",
      "uniform_scale": 1,
      "position": {
        "x": 430.776001,
        "y": 738.914917,
        "z": 2657.77002
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Start_Point",
      "uniform_scale": 1,
      "position": {
        "x": 729.526978,
        "y": -457.720856,
        "z": 231.772003
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Check_Point_2",
      "uniform_scale": 1,
      "position": {
        "x": 432.812012,
        "y": 268.643463,
        "z": 1832
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Check_Point_2",
      "uniform_scale": 1,
      "position": {
        "x": 547.317017,
        "y": 265.436798,
        "z": 1833.48999
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Check_Point_2",
      "uniform_scale": 1,
      "position": {
        "x": 250,
        "y": 271.255768,
        "z": 1832
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Check_Point_2",
      "uniform_scale": 1,
      "position": {
        "x": 130,
        "y": 266.659546,
        "z": 1832
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    }
  ],
  "VillageHard": [
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 433.334015,
        "y": -513.037354,
        "z": 96.240799
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 435.20401,
        "y": -513.162476,
        "z": 95.375198
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 437.582001,
        "y": -513.566772,
        "z": 94.366997
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 440.243988,
        "y": -513.761963,
        "z": 93.888298
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 442.778015,
        "y": -513.983032,
        "z": 93.335999
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Check_Point_2",
      "uniform_scale": 1,
      "position": {
        "x": 248.843994,
        "y": -45.584229,
        "z": 1096.150024
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Check_Point_1",
      "uniform_scale": 1,
      "position": {
        "x": 276.050995,
        "y": -274.875824,
        "z": 464.118011
      },
      "quat": {
        "w": 0.962966,
        "x": 0,
        "y": -0.269621,
        "z": 0
      }
    },
    {
      "name": "Start_Point",
      "uniform_scale": 1,
      "position": {
        "x": 439.385986,
        "y": -501.645935,
        "z": 114.804001
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Finish_Point",
      "uniform_scale": 1,
      "position": {
        "x": 211.158005,
        "y": 292.066498,
        "z": 1897.359985
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 449.298004,
        "y": -513.57428,
        "z": 94.264702
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 447.554993,
        "y": -513.726257,
        "z": 93.949699
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 444.868011,
        "y": -513.97467,
        "z": 93.357101
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    }
  ],
  "VillageMedium": [
    {
      "name": "Check_Point_1",
      "uniform_scale": 1,
      "position": {
        "x": 595.789978,
        "y": -145.276123,
        "z": 827.879028
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Start_Point",
      "uniform_scale": 1,
      "position": {
        "x": 801,
        "y": -481.165039,
        "z": 299.283997
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Check_Point_1",
      "uniform_scale": 1,
      "position": {
        "x": 852.960022,
        "y": -109.809311,
        "z": 847.317993
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Check_Point_2",
      "uniform_scale": 1,
      "position": {
        "x": 954.27002,
        "y": 387.389771,
        "z": 1827.089966
      },
      "quat": {
        "w": 0.966132,
        "x": 0,
        "y": 0.258047,
        "z": 0
      }
    },
    {
      "name": "Check_Point_2",
      "uniform_scale": 1,
      "position": {
        "x": 334.089996,
        "y": 404.545593,
        "z": 1607.920044
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Finish_Point",
      "uniform_scale": 1,
      "position": {
        "x": 605.559998,
        "y": 1014.658264,
        "z": 2583.449951
      },
      "quat": {
        "w": 0.999118,
        "x": 0,
        "y": -0.0419877,
        "z": 0
      }
    },
    {
      "name": "Finish_Point",
      "uniform_scale": 1,
      "position": {
        "x": 562.330017,
        "y": 1013.05835,
        "z": 2580.01001
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Finish_Point",
      "uniform_scale": 1,
      "position": {
        "x": 661.130005,
        "y": 1013.058411,
        "z": 2589.110107
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 805.97998,
        "y": -484.148041,
        "z": 291.459991
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 808.049988,
        "y": -484.111481,
        "z": 291.584015
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 799.973999,
        "y": -484.205536,
        "z": 290.96701
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 798.021973,
        "y": -484.156891,
        "z": 291.47699
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 795.872986,
        "y": -484.126862,
        "z": 291.640015
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 793.724976,
        "y": -484.082977,
        "z": 291.743011
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 801.661987,
        "y": -484.198792,
        "z": 291.009003
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Player_Start_Location",
      "uniform_scale": 1,
      "position": {
        "x": 803.802979,
        "y": -484.175079,
        "z": 291.208008
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Check_Point_2",
      "uniform_scale": 1,
      "position": {
        "x": 15,
        "y": 314.300995,
        "z": 1607.920044
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Check_Point_1",
      "uniform_scale": 1,
      "position": {
        "x": 1032.959961,
        "y": -148.53656,
        "z": 847.317993
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Check_Point_1",
      "uniform_scale": 1,
      "position": {
        "x": 1200,
        "y": -192.438019,
        "z": 847.317993
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Check_Point_2",
      "uniform_scale": 1,
      "position": {
        "x": 1400,
        "y": 347.761963,
        "z": 1827.089966
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    },
    {
      "name": "Check_Point_2",
      "uniform_scale": 1,
      "position": {
        "x": 1576,
        "y": 349.224152,
        "z": 1827.089966
      },
      "quat": {
        "w": 1,
        "x": 0,
        "y": 0,
        "z": 0
      }
    }
  ]
}